import classNames from 'classnames';
import { useState } from 'react';
import i18n from '@/settings/i18n';
import { priceFormater } from '@/settings/index';
import { priceFormatSuperscript } from '@/lib/price';
import { useProductPageContext } from '@/components/v2/product/hooks/useProductPageContext';
import { getSavingsAmount } from './helpers';
import PriceSavingsBadge from './PriceSavingsBadge';

const t = i18n.init('product');

const Disclaimer = () => (
  <div className="absolute left-0 top-[calc(100%+6px)] z-10 w-screen max-w-[calc(100vw-40px)] xs:max-w-[350px] lg:left-auto lg:right-0">
    <div className="rounded-md border bg-white px-3 py-2 text-center text-xs font-normal leading-tight text-gray-700 shadow-lg xs:px-5 xs:py-4">
      {t`This strikethrough comparison price shows how much you would pay for a new device, based on an average of retailer prices. The product compared may vary in its version, condition, warranty period, or other minor variations such as packaging.`}
    </div>
  </div>
);

type PricingBoxComparePriceProps = {
  align?: 'left' | 'right';
  className?: string;
};

export default function PricingBoxComparePrice({
  align = 'right',
  className,
}: PricingBoxComparePriceProps) {
  const {
    selectedSkuDetails: { compareAtPrice, finalPrice },
  } = useProductPageContext();
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  const savings = getSavingsAmount(compareAtPrice, finalPrice);

  if (!compareAtPrice) {
    return null;
  }

  return (
    <div
      className={classNames(
        'relative flex flex-wrap items-center gap-1 text-[12px] font-medium leading-none text-gray-700/50 outline-none',
        {
          'justify-end': align === 'right',
        },
        className,
      )}
    >
      <button
        type="button"
        className="flex items-center focus:outline-none"
        onClick={() => setShowDisclaimer(!showDisclaimer)}
        onBlur={() => setShowDisclaimer(false)}
        onMouseEnter={() => setShowDisclaimer(true)}
        onMouseLeave={() => setShowDisclaimer(false)}
      >
        <span id="e2e-pdp-price">
          {t`new`}{' '}
          <span translate="no" className="line-through">
            {priceFormatSuperscript(priceFormater.long(compareAtPrice))}
          </span>
        </span>
      </button>
      {savings != null && (
        <PriceSavingsBadge
          savings={savings}
          className="h-[18px] rounded bg-[#D5FFE2] px-1.5 text-[11px] font-extrabold text-[#128452]"
        />
      )}
      {showDisclaimer && <Disclaimer />}
    </div>
  );
}
